module.exports = new __parcel__URL__("open_daily_chest_button.54842738.png").toString();